module.exports = __webpack_public_path__ + "static/media/rectangle-xmark.effb816b.svg";